<template>
    <main class="container">
        <img class="gomonitor" src="/img/go_box.png" />

        <section>
            <h1>Welcome</h1>

            <p>
                This online enviroment will guide you step by step through the installation and configuration of the
                GoMonitor.
            </p>
        </section>

        <div class="row gx-5">
            <div class="col-5 col-sm-4 col-md-3 col-lg-2">
                <button class="btn btn-dark btn-lg" @click="connect">
                    Pair
                </button>
            </div>
            <div class="col-7 col-sm-8 col-md-9 col-lg-10">
                <router-link class="btn btn-dark btn-lg" to="/setup/1">
                    Start Setup
                </router-link>
            </div>
        </div>
    </main>
</template>

<script setup>
import { inject } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const GoConnect = inject('GoConnect');

function connect() {
    GoConnect.connect()
        .then(() => {
            router.push({ path: '/device/audio' });
        }).catch((error) => {
            GoConnect.handleError('error', error);
        });
}

</script>
